module.exports = __webpack_public_path__ + "static/media/nav_card_icon_2.af25eb7e.svg";